module.exports = "//static.hsappstatic.net/academy-public-ui/static-1.7342/images/homepage/hero-personas/thumbnail-08.webp"